import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { Schedule, SchedulesState, scheduleType } from '@/store/schedules/types'

const actions: ActionTree<SchedulesState, RootState> = {
  /**
   * スケジュールIDでスケジュールを取得する
   * @param {{
   *  id: string, // スケジュールID
   * }} param1
   */
  fetchScheduleById: (
    {
      commit,
      dispatch,
      getters,
    },
    { id }: { id: string },
  ) => axios.get(`/schedules/${id}`).then(async ({ data }) => {
    const { tutor, schedule }: { tutor: any, schedule: any } = data
    const { type }: { type: scheduleType } = schedule

    await Promise.all([
      dispatch('getTutor', { tutorId: tutor.tutorId }),
      dispatch('fetchMasterCampuses'),
    ])

    const from = moment(`${schedule.date}${schedule.startTime}`, 'YYYYMMDDhhmm')
    const to = moment(`${schedule.date}${schedule.endTime}`, 'YYYYMMDDhhmm')

    const s: Schedule = {
      id,
      type,
      campus: getters.findCampusByCode(schedule.campusCode),
      tutor: getters.findTutorById(tutor.tutorId),
      period: schedule.startPeriod,
      date: from.clone().startOf('date'),
      from,
      to,
      memo: schedule.memo,
      participantTime: schedule.time,
    }

    commit('gotSchedule', s)
  }),

  /*
  * スケジュール登録
  */
  registerSchedule: (
    { commit },
    { tutorId, schedule }: { tutorId: string, schedule: Schedule },
  ) => axios.post(
    `/tutors/${tutorId}/schedules/`,
    {
      ...schedule,
      campusCode: schedule.campus.code,
      date: schedule.date.format('YYYYMMDD'),
      startTime: schedule.from && schedule.from.format('HHmm'),
      endTime: schedule.to && schedule.to.format('HHmm'),
      time: schedule.participantTime,
    },
  ),

  /**
   * スケジュールを更新する
   * @param {{
   *  schedule: Schedule, // スケジュール
   * }}
   */
  updateSchedule: (
    { commit },
    { schedule }: { schedule: Schedule},
  ) => axios.put(
    `/tutors/${schedule.tutor.id}/schedules/${schedule.id}`,
    {
      ..._.omit(schedule, ['id', 'tutor']),
      campusCode: schedule.campus.code,
      date: schedule.date.format('YYYYMMDD'),
      startTime: schedule.from && schedule.from.format('HHmm'),
      endTime: schedule.to && schedule.to.format('HHmm'),
      time: schedule.participantTime,
    },
  ),
}

export default actions
